import { createSelector } from 'reselect';

const domain = ({ claim }) => claim;

export const getCountClaims = createSelector(domain, claim => claim.get('countClaims'));
